import React, { createContext, useContext, useReducer, useEffect } from 'react';

const CartContext = createContext();

const cartReducer = (state, action) => {
  switch (action.type) {
    case 'ADD_TO_CART':
      const existingItem = state.find(item => 
        item.name === action.payload.name && 
        item.selectedSize?.name === action.payload.selectedSize?.name
      );
      if (existingItem) {
        return state.map(item =>
          item.name === action.payload.name
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }
      return [...state, { ...action.payload, quantity: 1 }];
    case 'REMOVE_FROM_CART':
      return state.filter(item => 
        !(item.name === action.payload.name && 
          item.selectedSize?.name === action.payload.selectedSize?.name)
      );
    case 'UPDATE_QUANTITY':
      return state.map(item =>
        item.name === action.payload.name && 
        item.selectedSize?.name === action.payload.selectedSize?.name
          ? { ...item, quantity: action.payload.quantity }
          : item
      );
    case 'LOAD_CART':
      return action.payload;
    default:
      return state;
  }
};

export const CartProvider = ({ children }) => {
  const [cart, dispatch] = useReducer(cartReducer, []);

  useEffect(() => {
    const savedCart = localStorage.getItem('cart');
    if (savedCart) {
      dispatch({ type: 'LOAD_CART', payload: JSON.parse(savedCart) });
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);

  const addToCart = (product) => {
    dispatch({ type: 'ADD_TO_CART', payload: product });
  };

  const removeFromCart = (productName) => {
    dispatch({ type: 'REMOVE_FROM_CART', payload: productName });
  };

  const updateQuantity = (productName, quantity) => {
    dispatch({ type: 'UPDATE_QUANTITY', payload: { name: productName, quantity } });
  };

  const getCartTotal = () => {
    return cart.reduce((total, item) => {
      const price = parseFloat(item.price.replace('$', '').replace(' CAD', ''));
      return total + (price * item.quantity);
    }, 0);
  };

  return (
    <CartContext.Provider value={{ cart, addToCart, removeFromCart, updateQuantity, getCartTotal }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};